<template>
    <div>
        <table class="properties-table">
            <tbody>
                <tr>
                    <td class="properties-name">{{ $tr('Владелец') }}</td>
                    <td class="files-data">
                        <user-view v-if="ownerUser != undefined" :user="ownerUser" />
                        <user-view v-if="ownerCompany != undefined" :company="ownerCompany" />
                    </td>
                </tr>
                <tr>
                    <td class="properties-name">{{ $tr('Тип') }}</td>
                    <td class="files-data pa-2">{{ fileType(file) }}</td>
                </tr>
                <tr>
                    <td class="properties-name">{{ $tr('Создан') }}</td>
                    <td class="files-data pa-2">{{ created }}</td>
                </tr>
                <tr>
                    <td class="properties-name">{{ $tr('Создал') }}</td>
                    <td class="files-data">
                        <user-view :user="creator" />
                    </td>
                </tr>
                <tr v-if="trashed != undefined">
                    <td class="properties-name">{{ $tr('Удалён') }}</td>
                    <td class="files-data pa-2">{{ trashed }}</td>
                </tr>
                <tr v-if="trasher != undefined">
                    <td class="properties-name">{{ $tr('Удалил') }}</td>
                    <td class="files-data">
                        <user-view :user="trasher" />
                    </td>
                </tr>
                <tr>
                    <td class="properties-name">{{ $tr('Изменён') }}</td>
                    <td class="files-data pa-2">{{ modified }}</td>
                </tr>
                <tr>
                    <td class="properties-name">{{ $tr('Изменил') }}</td>
                    <td class="files-data">
                        <user-view :user="modifier" />
                    </td>
                </tr>
                <tr v-if="size != undefined">
                    <td class="properties-name">{{ $tr('Размер') }}</td>
                    <td class="files-data pa-2">{{ size }}</td>
                </tr>
                <tr v-if="size != undefined">
                    <td class="properties-name">{{ $tr('Занимает') }}</td>
                    <td class="files-data pa-2">{{ fullSize }}</td>
                </tr>
                <tr>
                    <td class="properties-name">{{ $tr('Права') }}</td>
                    <td class="files-data pa-2">{{ permissions }}</td>
                </tr>
                <tr v-if="folder != undefined">
                    <td class="properties-name">{{ $tr('Местоположение') }}</td>
                    <td class="files-data pa-2">
                        <v-btn variant="text" prepend-icon="mdi-folder" @click="onfolder">
                            <p>{{ folder }}</p>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
        </table>
        <v-textarea ref="description" v-if="edit_description" style="width:100%;" v-model="description" @keydown="handleKeydown" @focusout="handleBlur"></v-textarea>
        <div v-if="!edit_description" class="description">
            {{ file.description != undefined && file.description != "" ? file.description : $tr('Добавить описание') }}
            <tool-button icon="pencil" :title="$tr('Изменить описание')" :onclick="beginDescription" />
        </div>
        <h5 class="title">
            {{ $tr("Совместный доступ") }}
        </h5>
        <permissions :data="data" />
    </div>
</template>

<script>
import UserView from '@topomatic/tap/src/components/UserView.vue';
import Utils from '@topomatic/tap/src/utils';
import ToolButton from '@topomatic/tap/src/components/ToolButton.vue';
import AppConsts from '../consts';
import Permissions from './PermissionsView.vue';

export default {
    components: { UserView, ToolButton, Permissions },
    name: 'FileProperties',
    props: {
        data: Object,
    },
    data() {
        return {
            file: this.data.file,
            edit_description: false,
            description: undefined,
        };
    },
    computed: {
        drive() {
            const { path } = this.data;
            if ((path != undefined) && (path.length > 0)) {
                return path[0];
            }
            return undefined;
        },
        created() {
            return Utils.dateTimeToString(this.file.created);
        },
        creator() {
            const { creator } = this.file;
            if (creator != undefined) {
                return this.$api.get_user(creator);
            }
            return {};
        },
        ownerUser() {
            const { drive } = this;
            if ((drive != undefined) && (drive.user != undefined)) {
                return this.$api.get_user(drive.user);
            }
            return undefined;
        },
        ownerCompany() {
            const { drive } = this;
            if ((drive != undefined) && (drive.company != undefined)) {
                return this.$api.get_company(drive.company);
            }
            return undefined;
        },
        revision() {
            const { revisions } = this.file;
            if ((revisions != undefined) && (revisions.length > 0)) {
                let crevision = revisions[0];
                const active = this.file.revision;
                for (let i = revisions.length - 1; i >= 0; i--) {
                    if (active == revisions[i].id) {
                        crevision = revisions[i];
                        break;
                    }
                }
                return crevision;
            }
            return undefined;
        },
        trashed() {
            const { trashed } = this.file;
            if (trashed != undefined) {
                return Utils.dateTimeToString(trashed);
            }
            return undefined;
        },
        trasher() {
            const { trasher } = this.file;
            if (trasher != undefined) {
                return this.$api.get_user(trasher);
            }
            return undefined;
        },
        modified() {
            const { revision } = this;
            if (revision != undefined) {
                return Utils.dateTimeToString(revision.created);
            }
            return Utils.dateTimeToString(this.file.modified || this.file.created);
        },
        modifier() {
            const { revision } = this;
            if (revision != undefined) {
                return this.$api.get_user(revision.creator);
            }
            return this.$api.get_user(this.file.modifier || this.file.creator);
        },
        size() {
            const { revision } = this;
            if (revision != undefined) {
                return `${Utils.sizeToString(revision.length)} (${revision.length} ${this.$tr('Б')})`;
            }
            return null;
        },
        fullSize() {
            let size = 0;
            const { revisions } = this.file;
            if (revisions != undefined) {
                for (let i = 0; i < revisions.length; i++) {
                    size += revisions[i].length;
                }
            }
            return `${Utils.sizeToString(size)} (${size} ${this.$tr('Б')})`;
        },
        permissions() {
            return AppConsts.permission_name(this.data.permissions.value || this.data.permissions);
        },
        folder() {
            const { path } = this.data;
            if ((path != undefined) && (path.length > 1)) {
                return path[path.length - 2].name;
            }
            return undefined;
        },
    },
    methods: {
        onfolder() {
            const { path } = this.data;
            if ((path != undefined) && (path.length > 1)) {
                this.$router.push({
                    drive: path[0].id,
                    folder: path[path.length - 2].id,
                });
            }
        },
        commitDescription() {
            if (this.edit_description) {
                if (this.description != this.file.description) {
                    this.file.description = this.description;
                    this.$api.changeFileDescription(this.file.id, encodeURIComponent(this.description));
                }
                this.edit_description = false;
            }
        },
        beginDescription() {
            this.description = this.file.description;
            this.edit_description = true;
            this.$nextTick(() => {
                const textarea = this.$refs.description;
                textarea.focus();
            });
        },
        handleKeydown(e) {
            if (e.keyCode == 13) {
                if (e.shiftKey) {
                    return false;
                }
                this.commitDescription();
                e.preventDefault();
                return false;
            }
            return true;
        },
        handleBlur() {
            this.commitDescription();
        },
        fileType(file) {
            if (file.type == AppConsts.FOLDER_TYPE) {
                return this.$tr('Папка');
            }
            return file.type;
        },
    },
    watch: {
        data() {
            this.edit_description = false;
            this.file = this.data.file;
        },
    },
};
</script>

<style scoped>
.properties-table {
    width: 100%;
    margin-top: 12px;
}
.properties-table td {
    padding-top: 6px;
    padding-bottom: 6px;
}
.properties-name {
    color: var(--color-contrast-medium);
    font-weight: bold;
    min-width: 80px;
}
.files-data {
    vertical-align: middle !important;
    border: 0 !important;
}
.description {
justify-content: space-between!important;
    display: flex!important;
    align-items: center;
    color: var(--color-contrast-high);
    white-space: pre-wrap;
}
.title {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;
}
</style>
